module.exports = __webpack_public_path__ + "static/img/record1.db794e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/record1.png
// module id = 920
// module chunks = 1